/* eslint-disable consistent-return */
import AsyncStorage from '../../utils/AsyncStorage';
import { PAYOFF_DICTIONARY } from './constants';

export const getStatementToken = async () => AsyncStorage.getItem('STATEMENT_TOKEN');

export const removeStatementToken = async () => {
  await AsyncStorage.removeItem('STATEMENT_TOKEN');
};

export const setStatementToken = async (token) => {
  await AsyncStorage.setItem('STATEMENT_TOKEN', token);
};

const {
  dates: {
    default: {
      text: defaultDatesText,
      title: defaultDatesTitle,
    },
    isIneligible: {
      text: isIneligibleText,
      title: isIneligibleTitle,
    },
    isLoanMancodeY: {
      text: isLoanMancodeYText,
      title: isLoanMancodeYTitle,
    },
    paydown: {
      text: defaultPaydownText,
      title: defaultPaydownTitle,
    },
    payoff: {
      text: defaultPayoffText,
      title: defaulPayoffTitle,
    },
  },
  view: {
    default: {
      text: viewText,
      title: viewTitle,
    },
  },
} = PAYOFF_DICTIONARY;

export const getCopyForDatesVsView = ({
  formatMessage,
  hasStatementToView,
  isIneligible,
  isLoanMancodeY,
  isPastServicingPaymentCutOffDate,
  isPayDownAvailable,
  payoffStep,
}) => {
  if (isLoanMancodeY) {
    return {
      text: formatMessage({ id: isLoanMancodeYText }),
      title: formatMessage({ id: isLoanMancodeYTitle }),
    };
  }
  if (isPastServicingPaymentCutOffDate) {
    return {
      text: '',
      title: formatMessage({ id: isIneligibleTitle }),
    };
  }
  if (hasStatementToView) {
    return {
      text: formatMessage({ id: viewText }),
      title: formatMessage({ id: viewTitle }, { isPayDownAvailable }),
    };
  }
  if (isIneligible) {
    return {
      text: formatMessage({ id: isIneligibleText }),
      title: formatMessage({ id: isIneligibleTitle }),
    };
  }
  if (isPayDownAvailable) {
    if (payoffStep === 2) {
      return {
        text: formatMessage({ id: defaultPayoffText }),
        title: formatMessage({ id: defaulPayoffTitle }),
      };
    }
    return {
      text: formatMessage({ id: defaultPaydownText }),
      title: formatMessage({ id: defaultPaydownTitle }),
    };
  }
  return {
    text: formatMessage({ id: defaultDatesText }),
    title: formatMessage({ id: defaultDatesTitle }),
  };
};
